import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import React from 'react'
import LuxuryPlusBenefitIcon from './LuxuryPlusBenefitIcon'

interface Props {
  loyaltyInclusions: App.LoyaltyMemberInclusion[],
}

function LuxuryPlusInclusionsList(props: Props) {
  const {
    loyaltyInclusions,
  } = props

  return (
    <div>
      <VerticalSpacer gap={4}>
        {loyaltyInclusions.map((inclusion) => {
          return (
            <BodyTextBlock
              key={inclusion.id}
              variant="medium"
              weight="bold"
              startIcon={<LuxuryPlusBenefitIcon benefitType={inclusion.iconType as App.LoyaltyBenefitType} colour="loyalty" size="S" />}
            >
              {inclusion.description}
            </BodyTextBlock>
          )
        })}
      </VerticalSpacer>
    </div>
  )
}

export default LuxuryPlusInclusionsList
